import React, { FC, ReactNode } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { STRIPE_PUBLIC_KEY } from 'constants/config'

type Props = {
  children: ReactNode
}
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY)

const CheckoutWrapper: FC<Props> = (props) => {
  const { children } = props
  return <Elements stripe={stripePromise}>{children}</Elements>
}

export default CheckoutWrapper
